import { render } from "./RedirectToCardVamZaim.vue?vue&type=template&id=5e6ad302"
import script from "./RedirectToCardVamZaim.vue?vue&type=script&lang=js"
export * from "./RedirectToCardVamZaim.vue?vue&type=script&lang=js"

import "./RedirectToCardVamZaim.vue?vue&type=style&index=0&id=5e6ad302&lang=css"
import "./RedirectToCardVamZaim.vue?vue&type=style&index=1&id=5e6ad302&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__